import React, { Fragment, useContext, useEffect, useRef, useState } from "react"

import _ from "lodash"
import Icon from "@material-ui/core/Icon"
import useClickOutside from "../../hooks/useClickOutsite"
import { AppContext } from "../../app/App"
import { ReactComponent as DownloadIcon } from "../../img/icons/download_indicator.svg"
import AlertBox from "../alertBox"
import { NotificationKind } from "../../containers/notificationSlice"

const DownloadsBtn: React.FunctionComponent = () => {
  const [showDropdown, setShowDropdown] = useState(false)
  const [showAlert, setshowAlert] = useState(false)
  const dropdownRef = useRef()
  const appContext = useContext(AppContext)

  useEffect(() => {
    if (appContext.isDownloading) {
      setshowAlert(true)
      setTimeout(() => {
        setshowAlert(false)
      }, 2000)
    } else {
      setshowAlert(false)
    }
  }, [appContext.isDownloading])

  const handleClickOutside = () => {
    if (showDropdown) {
      setShowDropdown(false)
    }
  }

  useClickOutside({ ref: dropdownRef, onClickOutside: handleClickOutside })

  const clearFlightReportList = (linkName: string) => {
    return _.without(
      appContext.flightReports,
      _.find(appContext.flightReports, function (report) {
        return report.reportName === linkName
      })
    )
  }
  const onFlightReportClick = (e) => {
    if (e.target && e.target.download) {
      setTimeout(() => {
        const l = clearFlightReportList(e.target.download)
        appContext.handleChangeFlightReports(l)
      }, 1500)
    }
  }
  const getFlightReportLinkList = () => {
    return _.map(appContext.flightReports, (flightReport, index) => {
      if (flightReport && flightReport.reportName) {
        return (
          <li className="list-group-item" key={"att-" + index}>
            <a
              className="download"
              download={flightReport.reportName}
              href={
                "data:application/octet-stream," +
                encodeURIComponent(flightReport.reportContents)
              }
              onClick={onFlightReportClick}
            >
              {flightReport.reportName}
            </a>
          </li>
        )
      }
    })
  }

  return (
    <Fragment>
      <div className="ocs-btn-dropdown" ref={dropdownRef}>
        <button
          className={`ocs-btn ocs-btn-link ocs-pr-4`}
          onClick={() => {
            if (appContext.flightReports.length > 0) {
              setShowDropdown(!showDropdown)
            }
          }}
          disabled={
            !appContext.isDownloading
              ? appContext.flightReports.length <= 0
              : false
          }
        >
          {(appContext.flightReports.length > 0 ||
            appContext.isDownloading) && (
            <div className="ocs-pl-8">
              <span
                className={
                  "ocs-btn-download-amount " +
                  (appContext.isDownloading ? "pos-abs" : "")
                }
              >
                {appContext.flightReports.length}
              </span>
              {appContext.isDownloading && (
                <DownloadIcon className="ocs-btn-download-indicator ocs-svg-btn-icon" />
              )}
            </div>
          )}

          <span
            className={
              appContext.flightReports.length > 0 || appContext.isDownloading
                ? "ocs-btn-w-download-icon"
                : "ocs-btn-no-icon"
            }
          >
            Downloads
          </span>
          <Icon className="ocs-md-btn-icon">
            {showDropdown ? "expand_less" : "expand_more"}
          </Icon>
        </button>
        {showDropdown && (
          <ul className="links-container">{getFlightReportLinkList()}</ul>
        )}
        {showAlert && (
          <AlertBox
            type={NotificationKind.INFO}
            message="Your download was succesfully started."
            className="download-alert"
            onClose={() => setshowAlert(false)}
          />
        )}
      </div>
    </Fragment>
  )
}
export default DownloadsBtn

